<template>
  <div class="calendar" :style="calendarStyle">
    <month :month="month"
           :day-names="dayNames"
           :is-iframe="isIframe"
           :is-full-width="isFullWidth"
           :active-date-filter="activeDateFilter"
           v-for="month in months"
           @addToFilters="addToFilters($event.key, $event.value)"
           @removeFilter="removeFilter($event)"
           @loadCourseResults="populateCalendar($event)"
           :key="month.month_and_year"></month>
    <div class="calendar-navigation-container">
      <i class="fas fa-chevron-circle-left tdesk-neutral-medium"
         @click="loadPreviousCalendarSet()"></i>
      <i class="fas fa-chevron-circle-right tdesk-neutral-medium"
         @click="loadNextCalendarSet()"></i>
    </div>
  </div>
</template>
<script>
  import Month from './month.vue';

  export default {
    props: {
      months: {
        type: Array,
        required: true
      },
      dayNames: {
        type: Array,
        required: true
      },
      calendarNavigationBoundaries: {
        type: Object,
        required: true
      },
      isIframe: {
        type: Boolean,
        required: false
      },
      isFullWidth: {
        type: Boolean,
        required: false
      },
      activeDateFilter: {
        required: false
      }
    },
    components: {Month},
    computed: {
      calendarStyle() {
        if (this.isIframe) return 'margin-bottom: 0 !important;'
      }
    },
    methods: {
      loadPreviousCalendarSet() {
        this.addToFilters('from_date_filter', this.calendarNavigationBoundaries.previous.from_date_filter);
        this.addToFilters('to_date_filter', this.calendarNavigationBoundaries.previous.to_date_filter);
        this.$emit('loadCalendarSet', this.calendarNavigationBoundaries.previous);
      },
      loadNextCalendarSet() {
        this.addToFilters('from_date_filter', this.calendarNavigationBoundaries.next.from_date_filter);
        this.addToFilters('to_date_filter', this.calendarNavigationBoundaries.next.to_date_filter);
        this.$emit('loadCalendarSet', this.calendarNavigationBoundaries.next);
      },
      populateCalendar(filters) {
        this.$emit('loadCourseResults', filters);
      },
      addToFilters(key, value) {
        this.$emit('addToFilters', {key: key, value: value});
      },
      removeFilter(key) {
        this.$emit('removeFilter', key);
      }
    }
  };
</script>
